/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareIcon20Solid = forwardRef('CheckSquareIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 2a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4H6Zm8.87 6.091a1 1 0 0 0-1.413-1.414l-4.628 4.627a.25.25 0 0 1-.353 0L6.492 9.32a1 1 0 0 0-1.414 1.415l1.984 1.983a2.25 2.25 0 0 0 3.181 0l4.628-4.627Z" })));
});
